import { api } from '../../../../components/common';
import { Address, AddressWithValidation, ComponentValidation } from '../types';

// Convert server Address (verified: number) to client Address (verified: boolean)
const convertAddressFromApi = (serverAddress: any): Address => ({
  ...serverAddress,
  verified: serverAddress.verified === 1 || serverAddress.verified === true
});

// Convert client Address (verified: boolean) to server Address (verified: number)
const convertAddressToApi = (clientAddress: Address): any => ({
  ...clientAddress,
  verified: clientAddress.verified ? 1 : 0
});

export interface InferredComponents {
  street_number?: boolean;
  route?: boolean;
  subpremise?: boolean;
  neighborhood?: boolean;
  administrative_area_level_1?: boolean;
  postal_code?: boolean;
  country?: boolean;
}

export interface AddressValidationResponse {
  address: Address;
  componentValidation: ComponentValidation;
  hasInferredComponents: boolean;
  inferredComponents?: InferredComponents;
  inferredAddress?: Address;
}

export const addressValidatorApi = {
  validateAddress: (address: Address): Promise<AddressValidationResponse[]> =>
    api.post('/google/address-validator/validate', convertAddressToApi(address))
      .then(res => res.data.map((response: any) => ({
        address: convertAddressFromApi(response.address),
        componentValidation: response.componentValidation || {},
        hasInferredComponents: response.hasInferredComponents || false,
        inferredComponents: response.inferredComponents || undefined,
        inferredAddress: response.inferredAddress ? convertAddressFromApi(response.inferredAddress) : undefined
      }))),
};

